import type { SecureUser } from 'src/libs/wa/models/entities/SecureUser';
import type { User } from 'src/libs/wa/models/entities/User';
import type {
  NicknameResponse,
  RegisteredVia,
  SecureUserResponse,
  UserResponse
} from 'src/libs/wa/models/responses/UserResponse';
import { errorTranslator } from './errorTranslator';
import { secureCreditCardsTranslator } from './secureCreditCardsTranslator';

const secureUserTranslator = (response: SecureUserResponse): SecureUser => {
  return {
    accessToken: response.access_token,
    refreshToken: response.refresh_token,
    authorizedAt: new Date(response.authorized_at),
    confirmedAt: new Date(response.confirmed_at),
    email: response.email
  };
};

export const userTranslator = (
  response: UserResponse,
  userNicknameResponse: NicknameResponse | null,
  registeredViaResponse: RegisteredVia | null
): User => {
  const { user } = response;

  const translated = {
    id: user.id,
    language: user.language,
    nickname: userNicknameResponse?.nickname || null,
    createdAt: new Date(user.created_at),
    currentTravel: user.current_travel,
    secureUser: secureUserTranslator(user.secure_user),
    secureCreditCards: secureCreditCardsTranslator(user.secure_credit_cards),
    secureGmoCreditCards: secureCreditCardsTranslator(user.secure_gmo_credit_cards),
    secureUserProfile: user.secure_user_profile,
    ...errorTranslator(response),
    registeredVia: registeredViaResponse?.registered_via || null
  };

  return translated;
};
